import React from 'react';
import Button from '../primitives/Button';
import Reveal from '../primitives/Reveal';

interface IntroStatementProps {
  statement: string;
  link?: { label: string; to: string };
  /** Details-caps line above the statement, e.g. "Assessments". */
  eyebrow?: string;
  /** A body paragraph under the statement, in the same left column. */
  body?: string;
}

/**
 * The statement under the hero (guidelines p.53): the body face at display
 * size, sentence case, first line indented, in the left column, followed by
 * an underlined details-caps link.
 */
export default function IntroStatement({ statement, link, eyebrow, body }: IntroStatementProps) {
  return (
    <section className="mk-intro" aria-label="Introduction">
      <div className="mk-container">
        <Reveal>
          {eyebrow && <p className="mk-intro__eyebrow t-details t-muted">{eyebrow}</p>}
          <p className="mk-intro__text t-display">{statement}</p>
          {body && <p className="mk-intro__body t-body">{body}</p>}
          {link && (
            <div className="mk-intro__link">
              <Button variant="link" to={link.to}>
                {link.label}
              </Button>
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
